import {
  SANCTION_LIST_DETAIL_CLEAN_REQUEST,
  SANCTION_LIST_DETAIL_FETCH_REQUEST,
  SANCTION_LIST_DETAIL_FETCH_REQUEST_SUCCESS,
  SANCTION_LIST_DETAIL_FETCH_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const sanctionListDetailReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SANCTION_LIST_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SANCTION_LIST_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: {
          ...state.payload,
          [`${action.data.id}`]: action.data,
        },
        errors: {},
      });

    case SANCTION_LIST_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case SANCTION_LIST_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
      });

    default:
      return state;
  }
};

export default sanctionListDetailReducer;
